import { render, staticRenderFns } from "./cadastrar-servicos.vue?vue&type=template&id=d5cfab6a&scoped=true&"
import script from "./cadastrar-servicos.vue?vue&type=script&lang=js&"
export * from "./cadastrar-servicos.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar-servicos.vue?vue&type=style&index=0&id=d5cfab6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cfab6a",
  null
  
)

export default component.exports